<template>
  <div
    class="py-4 px-4 h-100"
  >
    <div
      v-if="isPageLoading"
      class="loader mx-auto h-100"
    />
    <template
      v-else
    >
      <section>
        <b-row>
          <b-col>
            <base-help-tooltip
              popover-placement="bottom"
            >
              <template v-slot:left>
                <div>
                  <h1 class="page-title">
                    Campaign Overview
                  </h1>
                </div>
              </template>
              <template v-slot:popover-body>
                <p>View the key delivery data from the campaign and see a breakdown of delivery and performance data per day.</p>
              </template>
            </base-help-tooltip>
          </b-col>
        </b-row>
        <b-row
          class="mt-6"
        >
          <b-col>
            <ReportStatements
              :type="'CAMPAIGN_OVERVIEW'"
              v-if="$route.name !== 'MultipleReportingIndex'"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <CampaignOverviewStats
              :delivery-list="deliveryList"
            />
          </b-col>
        </b-row>
      </section>
      <section>
        <reporting-delivery
          @updateStatsData="updateStatsData"
        />
      </section>
    </template>
  </div>
</template>

<script>
import {
  mapActions, mapState,
} from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

import ReportingDelivery from '@/modules/reporting/components/Delivery.vue';
import ReportStatements from '@/modules/reporting/components/ReportStatements.vue';
import CampaignOverviewStats from '@/modules/reporting/components/CampaignOverviewStats.vue';
import BaseHelpTooltip from '@/components/BaseHelpTooltip.vue';

export default {
  name: 'CampaignOverview',
  components: {
    BaseHelpTooltip,
    ReportingDelivery,
    ReportStatements,
    CampaignOverviewStats,
  },
  data() {
    return {
      isPageLoading: true,
      campaignIds: [],
      campaignPublishersList: [],
      publishersStats: [],
      deliveryList: [],
      sortBy: 'ctr',
    };
  },
  computed: {
    ...mapState('campaigns', [
      'order',
    ]),
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.FETCH_PUBLISHERS,
    ]),
    updateStatsData(deliveryData) {
      this.deliveryList = deliveryData;
    },
  },
  async created() {
    this.isPageLoading = false;
  },
};
</script>
